import HttpRepository from './httpRepository';

const RoleRepository = {
	addRoleToUser: ({ userId, roleId, securityGroupId }) =>
		HttpRepository.tradeshiftGo().post(`/rest/users/${userId}/roles/${roleId}/securityGroup/${securityGroupId}`),
	updateUserRole: (userId, roleId, securityGroupId) =>
		HttpRepository.tradeshiftGo().put(`/rest/users/${userId}/roles/${roleId}/securityGroup/${securityGroupId}`),
	removeRoleFromUser: ({ userId, roleId, securityGroupId }) =>
		HttpRepository.tradeshiftGo().delete(`/rest/users/${userId}/roles/${roleId}/securityGroup/${securityGroupId}`),
};

export default RoleRepository;
